<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">


      <vx-card title="Practical info" class="mt-base" no-shadow card-border>
        <!-- <h2 style="color:red">Please submit degrees from 1 to 100</h2> -->
       <div  class="vx-col lg:center w-full" >
               
                <!-- <div class="flex-1" style="padding-left:5px">
                  <vs-input label="Practical performance" max="100" min="0" type="number" v-model="traineePracticalModel.PracticalPerformance" class="mt-5 w-full" name="name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>        
                </div> -->
                <!-- <div class="flex-1" style="padding-left:5px">
                  <vs-input label="Final test" type="number" max="100" min="0" v-model="traineePracticalModel.PracticalFinalTest" class="mt-5 w-full" name="name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>        
                </div> -->
                <!-- <div class="flex-1" style="padding-left:5px">
                  <vs-input label="Progress test" max="100" min="0" type="number" v-model="traineePracticalModel.PracticalProgressTest" class="mt-5 w-full" name="name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>        
                </div> -->
                 <!-- <div class="flex-1" style="padding-left:5px">
                  <vs-input label="Theoretical Progress Tests" max="100" min="0" type="number" v-model="traineePracticalModel.TheoreticalProgressTests" class="mt-5 w-full" name="name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>        
                </div> -->
                 <div class="flex-1" style="padding-left:5px">
                  <vs-input :label="$t('Exercises')" type="number" max="100" min="0" v-model="traineePracticalModel.Exercises" class="mt-5 w-full" name="name" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>        
                </div>

                  </div>
                   <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
           <vs-button class="mr-6"  :disabled="!isFormValid" @click="submitData" >{{$t('Submit')}}</vs-button>
        <vs-button type="border" color="danger" :to="{name:'TraineeCoursesInstructor'}">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>
      </vx-card>
  
  </div>
</template>


<script>
import vSelect from 'vue-select'

import moduleTrainee from "@/store/user/trainee/moduleTrainee.js"; 
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
export default {
  components: {
  
     vSelect,
  },
  data() {
    return {
      traineePracticalModel:{},
      activePrompt:false,
      selected: [],
     
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
     
      rowDataForDelete: {},
      activeConfirm: false
    };
  },
  computed: {
    isFormValid() {
      return !this.errors.any() &&this.traineePracticalModel.Exercises>-1&&this.traineePracticalModel.Exercises<101
      &&this.traineePracticalModel.PracticalPerformance>-1&&this.traineePracticalModel.PracticalPerformance<101
       &&this.traineePracticalModel.Exercises&&this.traineePracticalModel.PracticalPerformance
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  

  },

  methods: {
  
     
     submitData() {
        debugger;
           this.$store.dispatch("traineeList/SaveTraineePractical", this.traineePracticalModel);
            // this.initValues(); 
            this.$router.push({name: 'CoursesInstructorTrainee'});
            // this.$router.push('/CoursesInstructorTrainee');  
         
    },
    

  },

  created() {
    debugger
    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
   // this.$store.dispatch("traineeList/fetchDataListItems");

      if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
    debugger;

     const TraineeID = this.$route.params.TraineeID
      const CourseClassID = this.$route.params.CourseClassID
      var data={
      TraineeID:TraineeID,
      CourseClassID:CourseClassID
      }
     if(TraineeID!=undefined)
     {

      this.$store.dispatch("traineeList/GetTraineePractical", data).then((response)=>{
        debugger;
      this.traineePracticalModel=response.data;
      });
     }
   // this.$store.dispatch("courseClassList/fetchDataListItems");
  
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
